/**
 * The honeypot field shared by every public lead / enquiry / privacy form and
 * the routes behind them.
 *
 * The field is a hidden text input that people never see and bots that fill
 * every input trip. The route then answers with a deliberate bare success and
 * delivers nothing, so a bot cannot tell it was caught.
 *
 * THE NAME MATTERS. It used to be `website` (and `company_website` in the chat
 * widget). Browser autofill and password managers key on a field's name, id and
 * label, and "website" is exactly what an address-book profile fills. A real
 * visitor whose browser filled the hidden field was thanked and delivered
 * nothing — the same silent loss the trap exists to cause for bots (#3091).
 * Pick a name no autofill profile targets: no `website`, `url`, `homepage`,
 * `company`, `email`, `phone`, `name`, `address` or `promo`/`coupon` in it.
 *
 * Browser and client forms import {@link HONEYPOT_FIELD_NAME}; routes import
 * {@link isHoneypotFilled}. Nothing else spells the name.
 */

/** The DOM `name` of the hidden input and the JSON key the forms post it under. */
export const HONEYPOT_FIELD_NAME = "hp_ref";

/** True when the honeypot value is a non-blank string, i.e. something filled it. */
export function isHoneypotFilled(value: unknown): boolean {
  return typeof value === "string" && value.trim().length > 0;
}
